import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import MapComponent from "./MapComponent";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import Geocode from 'react-geocode';
import _ from "lodash";

Geocode.setApiKey(process.env.GOOGLE_APIS_MAPS);

class GMap extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tmp: 1,
    };

    this.addDetail = this.addDetail.bind(this);
  }

  addDetail(detail){
    const {details, question} = this.props;

    if(details.length >= question.answersCount){
      return;
    }

    detail.microTime = getCurrentMicroTime(this.props.startTime);

    Geocode.fromLatLng(detail.lat, detail.lng).then(
      response => {
        detail.formattedAddress = response.results[0].formatted_address;

        details.push(detail);
        this.props.onDetailsUpdated(details.map((d, key) => {
          return {
            ...d,
            position: key
          }
        }));
        this.setState({
          tmp: this.state.tmp++
        })
      },
      error => {
        detail.formattedAddress = [detail.lat, detail.lng].join('; ');

        details.push(detail);
        this.props.onDetailsUpdated(details.map((d, key) => {
          return {
            ...d,
            position: key
          }
        }));
        this.setState({
          tmp: this.state.tmp++
        })
      }
    );
  }

  removeDetail(key){
    const {details} = this.props;

    this.props.onDetailsUpdated(details.filter((detail, dKey) => dKey !== key));
  }

  validate(){
    const {details} = this.props;
    const {answersMin, validationTexts} = this.props.question;

    let validate = {
      valid: true,
      errors: []
    };

    if(answersMin > 0 && answersMin > details.length){
      validate.errors.push(validationTexts.answersMin);
    }

    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render(){
    const {details, question} = this.props;

    return (
      <React.Fragment>
        <MapComponent
          googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + process.env.GOOGLE_APIS_MAPS + "&v=3.exp&libraries=geometry,drawing,places"}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `400px` }} />}
          mapElement={<div style={{ height: `100%` }} />}
          markers={details}
          defaultZoom={parseInt(question.zoom) || 8}
          defaultCenter={(question.lat && question.lng) ? { lat: parseFloat(question.lat), lng: parseFloat(question.lng) } : { lat: 52.237049, lng: 21.017532 }}
          handleAddMarker={this.addDetail}
        />

        {details.length > 0 && <ol className="mt-3 pl-0">
          {details.map((marker, key) => {
            return <li key={key} className="cafetery-wrap active">
              {key+1}. {marker.formattedAddress}

              <span
                className="float-right"
                onClick={() => this.removeDetail(key)}
              >
                <i className="fas fa-trash" />
              </span>
            </li>
          })}
        </ol>}
      </React.Fragment>
    )
  }
}

GMap.propTypes = {
  question: PropTypes.shape({
    answersCount: PropTypes.number.isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    position: PropTypes.number,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    answersMin: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(GMap);